import { render, staticRenderFns } from "./DiamondTag.vue?vue&type=template&id=5365d2f2&scoped=true&"
import script from "./DiamondTag.vue?vue&type=script&lang=js&"
export * from "./DiamondTag.vue?vue&type=script&lang=js&"
import style0 from "./DiamondTag.vue?vue&type=style&index=0&id=5365d2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365d2f2",
  null
  
)

export default component.exports